// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TheaterCanvasButtons-module__theaterButtonsWrapper--cW7TK {
  display: flex;
  align-items: center;
  gap: var(--theater-buttons-gap);
  width: 100%;
  container-type: size;
}

button.TheaterCanvasButtons-module__theaterControlButton--zidR_ {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: var(--theater-button-padding);
  font-size: var(--theater-button-font-size);
  transition: background-color 0.3s, color 0.3s, filter 0.3s;
  border-radius: var(--theater-button-border-radius);
  border-width: 1px;
  border-color: var(--theater-secondary-buttons-border-color);
}
button.TheaterCanvasButtons-module__theaterControlButton--zidR_ span {
  color: inherit;
}
@container (max-width: 18rem) {
  button.TheaterCanvasButtons-module__theaterControlButton--zidR_ {
    width: 2.25rem;
    height: 2.25rem;
  }
  button.TheaterCanvasButtons-module__theaterControlButton--zidR_ span {
    display: none;
  }
}
button.TheaterCanvasButtons-module__theaterControlButton--zidR_:hover {
  border-width: 1px;
}
button.TheaterCanvasButtons-module__theaterControlButton--zidR_:not(.TheaterCanvasButtons-module__playPauseButton--xIy86) {
  color: var(--theater-button-secondary-color);
  background-color: var(--theater-button-primary-color);
}
button.TheaterCanvasButtons-module__theaterControlButton--zidR_:not(.TheaterCanvasButtons-module__playPauseButton--xIy86):not(.TheaterCanvasButtons-module__disabled--irrQC):hover {
  color: var(--theater-button-tertiary-color);
  border-color: var(--theater-button-tertiary-color);
}
button.TheaterCanvasButtons-module__theaterControlButton--zidR_.TheaterCanvasButtons-module__playPauseButton--xIy86 {
  width: 6.125rem;
  color: var(--theater-button-primary-color);
  background-color: var(--theater-button-secondary-color);
}
@container (max-width: 18rem) {
  button.TheaterCanvasButtons-module__theaterControlButton--zidR_.TheaterCanvasButtons-module__playPauseButton--xIy86 {
    width: 3rem;
    height: 3rem;
  }
  button.TheaterCanvasButtons-module__theaterControlButton--zidR_.TheaterCanvasButtons-module__playPauseButton--xIy86 span {
    display: none;
  }
}
button.TheaterCanvasButtons-module__theaterControlButton--zidR_.TheaterCanvasButtons-module__playPauseButton--xIy86:not(.TheaterCanvasButtons-module__disabled--irrQC):hover {
  border-color: var(--theater-button-tertiary-color);
  background-color: var(--theater-button-tertiary-color);
}
button.TheaterCanvasButtons-module__theaterControlButton--zidR_:focus {
  border-width: 1px;
}
button.TheaterCanvasButtons-module__theaterControlButton--zidR_:focus-visible {
  border-width: 1px;
  border-color: var(--theater-button-tertiary-color);
}
button.TheaterCanvasButtons-module__theaterControlButton--zidR_.TheaterCanvasButtons-module__disabled--irrQC {
  color: var(--theater-button-disabled-color);
  border-color: var(--theater-button-disabled-background-color);
  background-color: var(--theater-button-disabled-background-color);
}`, "",{"version":3,"sources":["webpack://./src/components/TheaterCanvasButtons/TheaterCanvasButtons.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,WAAA;EACA,oBAAA;AACD;;AAEA;EAEC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,sCAAA;EAGA,0CAAA;EAeA,0DACC;EAGD,kDAAA;EACA,iBAAA;EACA,2DAAA;AAnBD;AADC;EACC,cAAA;AAGF;AACC;EAfD;IAgBE,cAAA;IACA,eAAA;EAEA;EADA;IACC,aAAA;EAGD;AACF;AASC;EACC,iBAAA;AAPF;AAWC;EACC,4CAAA;EACA,qDAAA;AATF;AAWE;EACC,2CAAA;EACA,kDAAA;AATH;AAaC;EACC,eAAA;EAQA,0CAAA;EACA,uDAAA;AAlBF;AAUE;EAFD;IAGE,WAAA;IACA,YAAA;EAPD;EAQC;IACC,aAAA;EANF;AACF;AAWE;EACC,kDAAA;EACA,sDAAA;AATH;AAaC;EACC,iBAAA;AAXF;AAaC;EACC,iBAAA;EACA,kDAAA;AAXF;AAcC;EACC,2CAAA;EACA,6DAAA;EACA,iEAAA;AAZF","sourcesContent":[".theaterButtonsWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: var(--theater-buttons-gap);\n\twidth: 100%;\n\tcontainer-type: size;\n}\n\nbutton.theaterControlButton {\n\t// Layout\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 0.5rem;\n\tpadding: var(--theater-button-padding);\n\n\t// Typography\n\tfont-size: var(--theater-button-font-size);\n\tspan {\n\t\tcolor: inherit;\n\t}\n\n\t// If this changes, also change theaterControlButton in ../Theater/MultiplayerToggle.module.scss\n\t@container (max-width: 18rem) {\n\t\twidth: 2.25rem;\n\t\theight: 2.25rem;\n\t\tspan {\n\t\t\tdisplay: none; // Hide button text on smaller screens\n\t\t}\n\t}\n\n\t// Style\n\ttransition:\n\t\tbackground-color 0.3s,\n\t\tcolor 0.3s,\n\t\tfilter 0.3s;\n\tborder-radius: var(--theater-button-border-radius);\n\tborder-width: 1px;\n\tborder-color: var(--theater-secondary-buttons-border-color);\n\n\t&:hover {\n\t\tborder-width: 1px;\n\t}\n\n\t// Button styles based on type and state below\n\t&:not(.playPauseButton) {\n\t\tcolor: var(--theater-button-secondary-color);\n\t\tbackground-color: var(--theater-button-primary-color);\n\n\t\t&:not(.disabled):hover {\n\t\t\tcolor: var(--theater-button-tertiary-color);\n\t\t\tborder-color: var(--theater-button-tertiary-color);\n\t\t}\n\t}\n\n\t&.playPauseButton {\n\t\twidth: 6.125rem;\n\t\t@container (max-width: 18rem) {\n\t\t\twidth: 3rem;\n\t\t\theight: 3rem;\n\t\t\tspan {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\tcolor: var(--theater-button-primary-color);\n\t\tbackground-color: var(--theater-button-secondary-color);\n\n\t\t&:not(.disabled):hover {\n\t\t\tborder-color: var(--theater-button-tertiary-color);\n\t\t\tbackground-color: var(--theater-button-tertiary-color);\n\t\t}\n\t}\n\n\t&:focus {\n\t\tborder-width: 1px;\n\t}\n\t&:focus-visible {\n\t\tborder-width: 1px;\n\t\tborder-color: var(--theater-button-tertiary-color);\n\t}\n\n\t&.disabled {\n\t\tcolor: var(--theater-button-disabled-color);\n\t\tborder-color: var(--theater-button-disabled-background-color);\n\t\tbackground-color: var(--theater-button-disabled-background-color);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"theaterButtonsWrapper": `TheaterCanvasButtons-module__theaterButtonsWrapper--cW7TK`,
	"theaterControlButton": `TheaterCanvasButtons-module__theaterControlButton--zidR_`,
	"playPauseButton": `TheaterCanvasButtons-module__playPauseButton--xIy86`,
	"disabled": `TheaterCanvasButtons-module__disabled--irrQC`
};
export default ___CSS_LOADER_EXPORT___;
